import { render, staticRenderFns } from "./access-points-page.vue?vue&type=template&id=6520b3c6&scoped=true&"
import script from "./access-points-page.vue?vue&type=script&lang=ts&"
export * from "./access-points-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520b3c6",
  null
  
)

export default component.exports